import { useEffect, useCallback } from "react";
import BackIcon from "../../../images/svg/back.svg";
import { KEYBOARD_KEYS, EVENTS, SCANNER_RESTRICTED_INPUTS } from "const";
import { eventsEmitter } from "utils/events";

export default function KeyPadHorizontal({ value, onChange, allowDecimal = true }) {
  const sVal = String(value ?? "");

  const handleKeyPress = useCallback(
    (val) => {
      if (val === "⌫") {
        const next = sVal.length <= 1 ? "" : sVal.slice(0, -1);
        onChange(next === "" ? 0 : next.includes(KEYBOARD_KEYS.DOT) ? next : Number(next));
        return;
      }

      if (val === KEYBOARD_KEYS.DOT) {
        if (!allowDecimal) return;
        if (sVal.includes(KEYBOARD_KEYS.DOT)) return;
        const next = sVal === "" ? "0." : sVal + ".";
        onChange(next);
        return;
      }

      const next = sVal === "0" ? String(val) : sVal + String(val);
      onChange(next.includes(KEYBOARD_KEYS.DOT) ? next : Number(next));
    },
    [sVal, onChange, allowDecimal],
  );

  useEffect(() => {
    const onKeyDown = (e) => {
      // If the user is typing in an input field, textarea, or dropdown, don't trigger keypad
      const target = e.target;
      if (
        target &&
        (SCANNER_RESTRICTED_INPUTS.includes(target.tagName) ||
          target.isContentEditable ||
          target.role === "option" ||
          target.role === "combobox" ||
          target.getAttribute("role") === "option" ||
          target.getAttribute("role") === "combobox" ||
          (target.classList &&
            typeof target.classList.contains === "function" &&
            target.classList.contains("MuiSelect-select")))
      ) {
        return;
      }

      const key = e.key;

      if (key >= "0" && key <= "9") {
        handleKeyPress(key);
      } else if (key === KEYBOARD_KEYS.BACKSPACE) {
        handleKeyPress("⌫");
      } else if (key === KEYBOARD_KEYS.DOT || key === KEYBOARD_KEYS.COMMA) {
        handleKeyPress(KEYBOARD_KEYS.DOT);
      }
    };

    const unsubscribeFn = eventsEmitter.on(EVENTS.KEY_DOWN, onKeyDown);
    return unsubscribeFn;
  }, [handleKeyPress]);

  const KEYS = ["1", "2", "3", "⌫", "4", "5", "6", "0", "7", "8", "9", "."];

  const styles = {
    keypad: {
      display: "grid",
      gridTemplateColumns: "repeat(4, 1fr)",
      marginTop: "8px",
      maxWidth: "360px",
    },
    keypadBtn: {
      padding: "14px 8px",
      border: "1px solid #cdcdcf",
      background: "#f0eff2",
      cursor: "pointer",
      fontWeight: 500,
      fontSize: "16px",
    },
    topLeft: { borderRadius: "10px 0 0 0" },
    topRight: { borderRadius: "0 10px 0 0" },
    bottomLeft: { borderRadius: "0 0 0 10px" },
    bottomRight: { borderRadius: "0 0 10px 0" },
    icon: { width: "19px", height: "19px" },
  };

  return (
    <div style={styles.keypad}>
      {KEYS.map((k) => {
        let extraStyle = {};
        if (k === "1") extraStyle = styles.topLeft;
        if (k === "⌫") extraStyle = styles.topRight;
        if (k === "7") extraStyle = styles.bottomLeft;
        if (k === ".") extraStyle = styles.bottomRight;

        return (
          <button
            key={k}
            type="button"
            style={{ ...styles.keypadBtn, ...extraStyle }}
            onClick={() => handleKeyPress(k)}
          >
            {k === "⌫" ? <img src={BackIcon} alt="Back" style={styles.icon} /> : k}
          </button>
        );
      })}
    </div>
  );
}
